import { render, staticRenderFns } from "./MSOSuppliers.vue?vue&type=template&id=65b90456&"
import script from "./MSOSuppliers.vue?vue&type=script&lang=js&"
export * from "./MSOSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports